import 'vue-good-table/dist/vue-good-table.css'
import 'vue-form-generator/dist/vfg.css'
import './styles.scss'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import VueAxios from 'vue-axios'
import VueAuthenticate from 'vue-authenticate'
import axios from 'axios'
import VModal from 'vue-js-modal'
import VueFormGenerator from 'vue-form-generator'
import CKEditor from '@ckeditor/ckeditor5-vue'
import VueSweetalert2 from 'vue-sweetalert2'

import VueGoodTablePlugin from './vendors/vue-good-table'
import { NavPlugin } from 'bootstrap-vue/esm/components/nav'
import { DropdownPlugin } from 'bootstrap-vue/esm/components/dropdown'
import { FormSelectPlugin } from 'bootstrap-vue/esm/components/form-select'
import { CardPlugin } from 'bootstrap-vue/esm/components/card'
import { TabsPlugin } from 'bootstrap-vue/esm/components/tabs'

import { baseUrl } from '@/config'
import store from './store/store'
import App from './App'
import router from './router'
import FieldYTDate from '@/components/common/FieldDate'
import FieldYTCKEditor from '@/components/common/FieldCKEditor'
import GridTable from '@/components/common/GridTable'
import ButtonLoader from '@/components/common/ButtonLoader'
import ModalComponent from '@/components/common/ModalComponent'

import { zipcodeValidator, confirmEqualValidator, validatePassword } from '@/lib/utils/validators'

import '@/lib/filters'

Vue.use(VueLodash, { name: 'custom', lodash: lodash })
Vue.use(VueAxios, axios)
Vue.use(VueAuthenticate, {
  baseUrl: `${baseUrl}oauth/adminToken`,
  loginUrl: '',
  tokenPrefix: 'ytauth',
  storageNamespace: 'yt-authenticate'
})
Vue.use(VModal, {
  dialog: true
})
Vue.use(CKEditor)
Vue.use(VueSweetalert2)

// Register form fields
Vue.component('fieldYTDate', FieldYTDate)
Vue.component('fieldYTCKEditor', FieldYTCKEditor)
Vue.use(VueFormGenerator, {
  validators: {
    zipcodeValidator,
    confirmEqualValidator,
    validatePassword  
  }
})

Vue.use(VueGoodTablePlugin)

/** Bootstrap **/
Vue.use(NavPlugin)
Vue.use(DropdownPlugin)
Vue.use(FormSelectPlugin)
Vue.use(CardPlugin)
Vue.use(TabsPlugin)

Vue.axios.baseUrl = baseUrl
Vue.config.productionTip = false

// Local Components
Vue.component('GridTable', GridTable)
Vue.component('ButtonLoader', ButtonLoader)
Vue.component('ModalComponent', ModalComponent)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js